import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../../../components/commonButton";
import withModal from "../../../components/withModal";

const StatusChangeModal = ({ onClose, currentStatus, onConfirm, isLoading }) => {
  const [selectedStatus, setSelectedStatus] = useState("");

  const getOptions = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return [
          { label: "Inactive", value: "inactive" },
        ];
      case "inactive":
        return [
          { label: "Active", value: "active" },
        ];
      default:
        return [
          { label: "Active", value: "active" },
          { label: "Inactive", value: "inactive" },
        ];
    }
  };

  const options = getOptions(currentStatus);

  useEffect(() => {
    setSelectedStatus("");
  }, [currentStatus]);

  const handleCheckboxChange = (value) => {
    setSelectedStatus(value);
  };

  const handleConfirm = () => {
    if (selectedStatus) {
      onConfirm(selectedStatus);
    }
  };

  return (
    <Modal.Body>
      <div className="text-center common-popup-heading">
        <p>Please select the new status for this user.</p>

        <div className="d-flex flex-column align-items-start mt-4 mb-4 ps-5">
          {options.map((option) => (
            <Form.Check
              key={option.value}
              type="checkbox"
              id={`status-${option.value}`}
              label={option.label}
              checked={selectedStatus === option.value}
              onChange={() => handleCheckboxChange(option.value)}
              className="mb-2"
            />
          ))}
        </div>

        <div className="d-flex align-items-center justify-content-center mt-4 gap-3">
          {/* <CommonButton
            onClick={onClose}
            title="CANCEL"
            variant="outline-primary"
            className="px-4"
            disabled={!selectedStatus}
          /> */}
          <CommonButton
            onClick={handleConfirm}
            title="YES"
            variant="primary"
            className="px-4"
            disabled={!selectedStatus}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal.Body>
  );
};

export default withModal(StatusChangeModal);

